export default __webpack_public_path__ + "static/tablet_KV12-8192da093c1c5ddfda3ae5ebe0b5e9c1.mp4";